// Copyright (c) 2017 Deere & Company

import LaborRateChanges from '../state/labor-rate-changes';
import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const updateLaborRateChanges = (state, action) =>
    LaborRateChanges.update(state, {
        $set: action.data
    });

export default (state = getWipDefaultState().laborRateChanges, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_LABOR_RATE_CHANGES]: updateLaborRateChanges
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/labor-rate-changes.js